import { Controller } from '@hotwired/stimulus';
class default_1 extends Controller {
    connect() {
        this.toggleSubmit();
        this.checkboxTargets.forEach((cb) => {
            cb.addEventListener('change', () => this.toggleSubmit());
        });
    }
    toggleSubmit() {
        const anyChecked = this.checkboxTargets.some((cb) => cb.checked);
        this.submitTargets.forEach((btn) => {
            btn.disabled = !anyChecked;
        });
    }
}
default_1.targets = ['checkbox', 'submit'];
export default default_1;
